import { ElMessageBox } from 'element-plus'
import { VNode } from 'vue'
import { useI18n } from 'vue-i18n'

export const useConfirmWarning = () => {
  const { t } = useI18n()
  const confirmPositive = (params: {
    text: string | VNode
    title: string
    onConfirm: (event?: unknown) => void
    onError?: (error?: unknown) => void
  }) => {
    const { text, onConfirm, title, onError } = params
    ElMessageBox.confirm(text, title, {
      confirmButtonText: t('buttons.ok'),
      confirmButtonClass:
        'el-button--primary tw-uppercase tw-font-bold tw-text-base app-button',
      cancelButtonText: t('buttons.cancel'),
      cancelButtonClass:
        'el-button--primary is-plain tw-uppercase tw-font-bold tw-text-base app-button',
      center: true,
      autofocus: false,
    })
      .then(() => {
        onConfirm()
      })
      .catch((error) => {
        if (onError) {
          onError(error)
        } else {
          // eslint-disable-next-line no-console
          console.error(error)
        }
      })
  }

  return {
    confirmPositive,
  }
}
